/**
 * sections.js
 *
 * Import the JS for your sections here.
 *
 */
import ComponentInit from '../js/utils/ComponentInit';
import AlertBanner from './AlertBanner/AlertBanner';
import CardCarousel from './CardCarousel/CardCarousel';
import FixedHeader from './Header/Shared/FixedHeader';
import HeaderSearch from './Header/Shared/HeaderSearch';
import MainNav from './Header/Desktop/MainNav';
import MobileNav from './Header/Mobile/MobileNav';
import NavbarToggler from './Header/Mobile/NavbarToggler';
import SearchToggler from './Header/Mobile/SearchToggler';

// import AssetsListing from './AssetsListing/AssetsListing';
// import LocationListing from './LocationListing/LocationListing';
// import ArticleListing from './ArticleListing/ArticleListing';
// import PeopleListing from './PeopleListing/PeopleListing';
// import SearchBlock from './SearchBlock/SearchBlock';

// import './AlgoliaSearch/AlgoliaSearch';

// // Format:
// // data-component-name: ComponentFunction
// // we shall order these in page load critical first
const componentList = {
    AlertBanner,
    CardCarousel,
    FixedHeader,
    HeaderSearch,
    MainNav,
    MobileNav,
    NavbarToggler,
    SearchToggler,
    // AssetsListing,
    // LocationListing,
    // ArticleListing,
    // PeopleListing,
    // SearchBlock,
};

// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
export default ComponentInit(componentList);
